// The demo's cloud connection: Kodem's Entra app the customer's admin grants
export const FOUNDRY_DEMO_APP_ID = "8b1f6c2e-4d3a-4f5b-9c7e-2a6d0e1f3b49"
